import { getDesignEmbeds } from "./designEmbeds";
import { getCollectionNaming } from "./collectionNaming";

const muroDesigns = [
  {
    id: "acqua",
    title: "Acqua",
    thumbnail: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/79frj2f7_Acqua%20Principal.jpg",
    detailImage: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/z7fgb7h2_Aqcua%20Vista%201.jpg",
    contextImage: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/lq2t9dw9_Aqcua%20Vista%202.jpg",
    measurementImage: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/uwaulzew_Diagrama%20medidas%20Acqua.png",
    photoReelImages: [
      {
        id: "acqua-reel-1",
        src: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/076rib4s_Copia%20de%20ACQUA%20CLOSEUP.png",
        alt: "Acqua closeup",
      },
      {
        id: "acqua-reel-2",
        src: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/bvqu3zsd_Copia%20de%20ACQUA%20PROB.png",
        alt: "Acqua ambientada",
      },
      {
        id: "acqua-reel-3",
        src: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/076rib4s_Copia%20de%20ACQUA%20CLOSEUP.png",
        alt: "Acqua closeup 2",
      },
      {
        id: "acqua-reel-4",
        src: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/bvqu3zsd_Copia%20de%20ACQUA%20PROB.png",
        alt: "Acqua ambientada 2",
      },
      {
        id: "acqua-reel-5",
        src: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/076rib4s_Copia%20de%20ACQUA%20CLOSEUP.png",
        alt: "Acqua closeup 3",
      },
      {
        id: "acqua-reel-6",
        src: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/bvqu3zsd_Copia%20de%20ACQUA%20PROB.png",
        alt: "Acqua ambientada 3",
      },
    ],
    externalUrl: "https://www.aristaconcreto.com/producto/acqua/",
    description: {
      es: "Acqua nace de una forma triangular, con un relieve tridimensional que asemeja las ondas del agua. Su uso en interiores o exteriores es ideal para formar diferentes patrones y composiciones.",
      en: "Acqua is born from a triangular geometry with a three-dimensional relief that recalls water ripples. It works in interiors or exteriors and is ideal for creating varied patterns and compositions.",
    },
    specs: {
      dimensions: "21.60 × 25.00 × 4.00 cm",
      piecesPerM2: "36.95 pzas/m²",
      weightPerPiece: "1.06 kg/pza",
      weightPerM2: "39.17 kg/m²",
    },
  },
  {
    id: "alpes",
    title: "Alpes",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Alpes-Pieza-qwq8cikf21s05bbtnkcghjbqrriv24h3k8csajnndc.png",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/2024/11/Alpes-1-1024x791.png",
    measurementImage: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/oz0ob225_Diagrama%20Medidas%20Alpes%20.jpg",
    externalUrl: "https://www.aristaconcreto.com/producto/alpes-2/",
    description: {
      es: "En la colección de relieves, Alpes es un juego de piezas cuadradas a diferentes alturas que crea una inmensidad de combinaciones distintas para muros interiores o exteriores.",
      en: "Within the relief collection, Alpes combines square pieces at different heights to create countless wall compositions for interior or exterior use.",
    },
    variants: [
      { label: "A", dimensions: "10.00 × 10.00 × 1.00 cm", piecesPerM2: "100.00 pzas/m²", weightPerPiece: "0.185 kg/pza" },
      { label: "B", dimensions: "10.00 × 10.00 × 2.00 cm", piecesPerM2: "100.00 pzas/m²", weightPerPiece: "0.200 kg/pza" },
      { label: "C", dimensions: "10.00 × 10.00 × 3.00 cm", piecesPerM2: "100.00 pzas/m²", weightPerPiece: "0.595 kg/pza" },
      { label: "D", dimensions: "10.00 × 10.00 × 4.00 cm", piecesPerM2: "100.00 pzas/m²", weightPerPiece: "0.835 kg/pza" },
      { label: "E", dimensions: "10.00 × 10.00 × 5.00 cm", piecesPerM2: "100.00 pzas/m²", weightPerPiece: "0.975 kg/pza" },
    ],
  },
  {
    id: "angular",
    title: "Angular",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Copia-de-T007-scaled-qtyn1f05a1697uau7vesw6g38mjihd5pxltc56ntw0.jpeg",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/2024/06/Captura-de-pantalla-2024-06-20-093042-1024x438.png",
    externalUrl: "https://www.aristaconcreto.com/producto/angular/",
    description: {
      es: "Una pieza diseñada en concreto basada en la geometría de un cuadrado con detalles tridimensionales, lo cual la hace versátil para cualquier entorno interior o exterior.",
      en: "A concrete piece based on square geometry with three-dimensional detailing, making it versatile for virtually any interior or exterior setting.",
    },
    specs: {
      dimensions: "16.00 × 16.00 × 4.30 cm",
      piecesPerM2: "39.07 pzas/m²",
      weightPerPiece: "0.74 kg/pza",
      weightPerM2: "28.91 kg/m²",
    },
  },
  {
    id: "arista",
    title: "Arista",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Copia-de-Arista-Pieza-qpy0uuo87nt8cy17cxrdd3z5pei9y9kgq1exs9yt5c.png",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/2024/06/Captura-de-pantalla-2024-06-20-095035-1024x451.png",
    externalUrl: "https://www.aristaconcreto.com/producto/arista/",
    description: {
      es: "Arista es una pieza de forma cuadrada con un relieve tridimensional que añade personalidad a diferentes acomodos; su uso puede ser en interiores o exteriores.",
      en: "Arista is a square piece with a three-dimensional relief that adds personality to multiple layouts, indoors or outdoors.",
    },
    specs: {
      dimensions: "16.00 × 16.00 × 3.60 cm",
      piecesPerM2: "39.07 pzas/m²",
      weightPerPiece: "1.03 kg/pza",
      weightPerM2: "40.24 kg/m²",
    },
  },
  {
    id: "arrecife",
    title: "Arrecife",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Arrecife-Pieza-qwoopycspqf78q5s7g39udjlybw74hg0kh1bravhn4.png",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/2024/11/Arrecife-1024x791.png",
    measurementImage: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/ptv9pdpf_Diagrama%20Medidas%20%20Arrecife.png",
    externalUrl: "https://www.aristaconcreto.com/producto/arrecife/",
    description: {
      es: "Arrecife nace de un diseño geométrico alterado con una forma de estrella de tres puntas y permite generar acomodos que no pasarán desapercibidos, en interiores o exteriores.",
      en: "Arrecife is built from an altered geometric design with a three-point star shape, allowing striking arrangements for interior or exterior spaces.",
    },
    specs: {
      dimensions: "21.14 × 19.80 × 4.77 cm",
      piecesPerM2: "50.00 pzas/m²",
      weightPerPiece: "0.97 kg/pza",
      weightPerM2: "48.50 kg/m²",
    },
  },
  {
    id: "boomer",
    title: "Boomer",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Boomer-2-scaled-qwo8jimzwf3z766k86ohbuoas4neka7mtoh3fwgj68.jpeg",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/2024/11/Boomer-1024x791.png",
    measurementImage: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/jwkhim55_Diagrama%20Medidas%20%20Boomer.png",
    externalUrl: "https://www.aristaconcreto.com/producto/boomer/",
    description: {
      es: "Una pieza geométrica que juega con los relieves y las formas. Boomer es versátil para utilizarse en todos los entornos, interiores y exteriores.",
      en: "A geometric piece that plays with reliefs and form. Boomer is versatile enough for interior and exterior environments alike.",
    },
    specs: {
      dimensions: "15.77 × 18.20 × 4.00 cm",
      piecesPerM2: "52.26 pzas/m²",
      weightPerPiece: "0.71 kg/pza",
      weightPerM2: "37.10 kg/m²",
    },
  },
  {
    id: "cali",
    title: "Cali",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Copia-de-IMG_0160-scaled-qpy173ij8ykpm28uuqbeciqcb45f8b6kqndnv1t634.jpg",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/2024/06/Captura-de-pantalla-2024-06-20-095929-1024x462.png",
    externalUrl: "https://www.aristaconcreto.com/producto/cali/",
    description: {
      es: "Una forma cuadrada con un relieve que permite jugar con diferentes acomodos. Cali es ideal para cualquier entorno, interior o exterior.",
      en: "A square form with relief that invites multiple layouts. Cali is ideal for nearly any environment, indoors or out.",
    },
    specs: {
      dimensions: "16.00 × 16.00 × 3.60 cm",
      piecesPerM2: "39.07 pzas/m²",
      weightPerPiece: "1.16 kg/pza",
      weightPerM2: "45.32 kg/m²",
    },
  },
  {
    id: "caramel",
    title: "Caramel",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Copia-de-IMG_0306-scaled-qpy2ht3svkiokge93f6yr8dz1fx2qtmdhuhbf2juvk.jpg",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/2024/06/Captura-de-pantalla-2024-06-20-102933-1024x541.png",
    externalUrl: "https://www.aristaconcreto.com/producto/caramel/",
    description: {
      es: "Con una forma hexagonal y una base plana, Caramel es versátil para todo tipo de ambientes interiores o exteriores y además permite combinarse con otros modelos de piezas.",
      en: "With its hexagonal shape and flat base, Caramel adapts to all kinds of interior and exterior settings and can be combined with other models.",
    },
    specs: {
      dimensions: "15.01 × 13.00 × 1.30 cm",
      piecesPerM2: "67.28 pzas/m²",
      weightPerPiece: "0.375 kg/pza",
      weightPerM2: "25.23 kg/m²",
    },
  },
  {
    id: "cenote",
    title: "Cenote",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Cenote-Pieza-qwq9n93ivhr9fbfuqrmngqqu3h5vsc0mnk3xbucxzk.png",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/2024/11/Cenote-1024x791.png",
    externalUrl: "https://www.aristaconcreto.com/producto/cenote-2/",
    description: {
      es: "Cenote expone una composición creativa que fusiona diferentes alturas para crear patrones dinámicos con juegos de sombras y luces, logrando una estética no monótona en cualquier entorno arquitectónico.",
      en: "Cenote is a creative composition that mixes different heights to build dynamic patterns with strong shadow-and-light interplay and a non-monotonous architectural reading.",
    },
    variants: [
      { label: "A", dimensions: "10.00 × 10.00 × 1.00 cm", piecesPerM2: "100.00 pzas/m²", weightPerPiece: "0.170 kg/pza" },
      { label: "B", dimensions: "10.00 × 10.00 × 2.00 cm", piecesPerM2: "100.00 pzas/m²", weightPerPiece: "0.260 kg/pza" },
      { label: "C", dimensions: "10.00 × 10.00 × 3.00 cm", piecesPerM2: "100.00 pzas/m²", weightPerPiece: "0.410 kg/pza" },
      { label: "D", dimensions: "10.00 × 10.00 × 4.00 cm", piecesPerM2: "100.00 pzas/m²", weightPerPiece: "0.520 kg/pza" },
      { label: "E", dimensions: "10.00 × 10.00 × 5.00 cm", piecesPerM2: "100.00 pzas/m²", weightPerPiece: "0.800 kg/pza" },
    ],
  },
  {
    id: "creciente",
    title: "Creciente",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Copia-de-Creciente-Pieza-scaled-qu2l78tgab3er8dbp2y5tpo0c1f29sky8i4kzmenm8.jpg",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Copia-de-Creciente-Pieza-scaled-qu2l78tgab3er8dbp2y5tpo0c1f29sky8i4kzmenm8.jpg",
    externalUrl: "https://www.aristaconcreto.com/producto/creciente/",
    description: {
      es: "Una forma de pentágono con relieves tridimensionales curvos. Creciente da pie a formar patrones y acomodos en todos los entornos, interiores y exteriores.",
      en: "A pentagonal form with curved three-dimensional reliefs. Creciente is conceived to build patterns and arrangements across interior and exterior environments.",
    },
    specs: {
      dimensions: "23.66 × 30.00 × 4.20 cm",
      piecesPerM2: "22.22 pzas/m²",
      weightPerPiece: "1.94 kg/pza",
      weightPerM2: "43.11 kg/m²",
    },
  },
  {
    id: "dalia",
    title: "Dalia",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/DALIA-SUPERIOR-qwpz4olkclivh3c0bmmvqrul5t30ou4fltaw4xo1zk.png",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/2024/11/Dalia-1024x791.png",
    externalUrl: "https://www.aristaconcreto.com/producto/dalia/",
    description: {
      es: "Inspirado en las losetas artesanales, Dalia es un modelo clásico que con su patrón en forma de flor se vuelve el elemento que destacará en el espacio donde se coloque, interior o exterior.",
      en: "Inspired by handcrafted tiles, Dalia is a classic model whose floral pattern becomes the standout element wherever it is placed, indoors or outdoors.",
    },
    specs: {
      dimensions: "10.00 × 10.00 × 1.24 cm",
      piecesPerM2: "100.00 pzas/m²",
      weightPerPiece: "0.17 kg/pza",
      weightPerM2: "17.00 kg/m²",
    },
  },
  {
    id: "desfase-a",
    title: "Desfase A",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Desfase-A-scaled-qu9879bouzcadwk5apprz0pwl7btd6x66f3dq35dzk.jpg",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/2024/09/Desface-A-1-1024x791.png",
    externalUrl: "https://www.aristaconcreto.com/producto/desfase-a/",
    description: {
      es: "Una pieza diseñada en concreto basada en la geometría de un cuadrado con relieve. Desfase A permite jugar con diferentes acomodos y es ideal para interiores o exteriores.",
      en: "A concrete piece built from square geometry with relief. Desfase A allows multiple arrangements and is ideal for interior or exterior settings.",
    },
    specs: {
      dimensions: "25.00 × 25.00 × 5.60 cm",
      piecesPerM2: "16.00 pzas/m²",
      weightPerPiece: "3.65 kg/pza",
      weightPerM2: "58.40 kg/m²",
    },
  },
  {
    id: "desfase-b",
    title: "Desfase B",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Desfase-B-scaled-qu98olgiwz2oizdk27i1yn7z11vjc7qxw89sdtfz80.jpeg",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Desfase-B-scaled-qu98olgiwz2oizdk27i1yn7z11vjc7qxw89sdtfz80.jpeg",
    externalUrl: "https://www.aristaconcreto.com/producto/desfase-b/",
    description: {
      es: "Una alternativa a la clásica Desfase con un relieve menos pronunciado que le añade versatilidad para su uso en distintos entornos.",
      en: "A softer alternative to the classic Desfase, with a less pronounced relief that adds versatility across different environments.",
    },
    specs: {
      dimensions: "25.00 × 25.00 × 4.20 cm",
      piecesPerM2: "16.00 pzas/m²",
      weightPerPiece: "2.78 kg/pza",
      weightPerM2: "44.48 kg/m²",
    },
  },
  {
    id: "dot",
    title: "Dot",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Copia-de-IMG_0284-scaled-qu2mig9nirptu7ss1hjn1stecoqoujzne5mgnwev4g.jpg",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Copia-de-IMG_0284-scaled-qu2mig9nirptu7ss1hjn1stecoqoujzne5mgnwev4g.jpg",
    externalUrl: "https://www.aristaconcreto.com/producto/dot/",
    description: {
      es: "Una pieza con forma cuadrada que agrega un relieve circular en su centro y le da su nombre. Dot es ideal para distintos acomodos en interiores o exteriores.",
      en: "A square piece with a circular relief at its center—the detail that gives Dot its name. It is ideal for varied indoor and outdoor compositions.",
    },
    specs: {
      dimensions: "16.00 × 16.00 × 2.00 cm",
      piecesPerM2: "39.00 pzas/m²",
      weightPerPiece: "1.10 kg/pza",
      weightPerM2: "42.90 kg/m²",
    },
  },
  {
    id: "duna",
    title: "Duna",
    thumbnail: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/elementor/thumbs/Duna-scaled-qwprg7ck3x1mi6xnrmadu1imwptblvipxdaddxlu6o.jpg",
    detailImage: "https://67.225.154.231/plesk-site-preview/www.aristaconcreto.com/https/67.225.154.231/wp-content/uploads/2024/11/Duna-1024x791.png",
    externalUrl: "https://www.aristaconcreto.com/producto/pixel/",
    description: {
      es: "Una pieza de forma cuadrada. Duna juega con sus relieves curvos en la parte superior y permite diferentes acomodos para cualquier entorno interior o exterior.",
      en: "A square piece whose curved top relief creates movement and allows different compositions for interior and exterior environments.",
    },
    specs: {
      dimensions: "10.00 × 10.00 × 1.85 cm",
      piecesPerM2: "100.00 pzas/m²",
      weightPerPiece: "0.32 kg/pza",
      weightPerM2: "32.00 kg/m²",
    },
  },
];

const sharedCollectionUi = {
  "es-MX": {
    detailKicker: "Pieza",
    specsLabel: "Ficha técnica",
    variantsLabel: "Variantes",
    dimensionsLabel: "Dimensiones",
    piecesPerM2Label: "Piezas por m²",
    weightPerPieceLabel: "Peso por pieza",
    weightPerM2Label: "Peso por m²",
    sourceCta: "Ver en sitio original",
    jumpCta: "Ver diseño",
    contactCta: "Solicitar asesoría",
    note: "Cotas indicadas en cm.",
    cardsPrefix: "Diseño",
  },
  "es-ES": {
    detailKicker: "Pieza",
    specsLabel: "Ficha técnica",
    variantsLabel: "Variantes",
    dimensionsLabel: "Dimensiones",
    piecesPerM2Label: "Piezas por m²",
    weightPerPieceLabel: "Peso por pieza",
    weightPerM2Label: "Peso por m²",
    sourceCta: "Ver en sitio original",
    jumpCta: "Ver diseño",
    contactCta: "Solicitar asesoramiento",
    note: "Cotas indicadas en cm.",
    cardsPrefix: "Diseño",
  },
  "en-US": {
    detailKicker: "Piece",
    specsLabel: "Technical sheet",
    variantsLabel: "Variants",
    dimensionsLabel: "Dimensions",
    piecesPerM2Label: "Pieces per m²",
    weightPerPieceLabel: "Weight per piece",
    weightPerM2Label: "Weight per m²",
    sourceCta: "View original source",
    jumpCta: "View design",
    contactCta: "Request guidance",
    note: "Dimensions shown in cm.",
    cardsPrefix: "Design",
  },
};

const collectionOverviewCopyByLocale = {
  "es-MX": {
    muro: {
      overviewTitle: "Explora cada pieza como una biblioteca material de gran detalle.",
      overviewDescription: "Una vista editorial para recorrer las piezas que integran MURO con acceso rápido a cada diseño y su ficha técnica.",
    },
    celosias: {
      overviewTitle: "Explora cada celosía como un módulo de luz, sombra y ventilación.",
      overviewDescription: "Una vista editorial para recorrer las celosías disponibles con acceso rápido a cada patrón y su ficha técnica.",
    },
    paneles: {
      overviewTitle: "Explora cada panel como una superficie protagonista y precisa.",
      overviewDescription: "Una lectura editorial para revisar formatos, acabados y presencia material antes de entrar a cada panel individual.",
    },
    pisos: {
      overviewTitle: "Explora cada piso como una base material de lectura arquitectónica.",
      overviewDescription: "Una vista clara para navegar los modelos de piso y abrir cada ficha con su información técnica y visual.",
    },
  },
  "es-ES": {
    muro: {
      overviewTitle: "Explora cada pieza como una biblioteca material de gran detalle.",
      overviewDescription: "Una vista editorial para recorrer las piezas que integran MURO con acceso rápido a cada diseño y su ficha técnica.",
    },
    celosias: {
      overviewTitle: "Explora cada celosía como un módulo de luz, sombra y ventilación.",
      overviewDescription: "Una vista editorial para recorrer las celosías disponibles con acceso rápido a cada patrón y su ficha técnica.",
    },
    paneles: {
      overviewTitle: "Explora cada panel como una superficie protagonista y precisa.",
      overviewDescription: "Una lectura editorial para revisar formatos, acabados y presencia material antes de entrar a cada panel individual.",
    },
    pisos: {
      overviewTitle: "Explora cada pavimento como una base material de lectura arquitectónica.",
      overviewDescription: "Una vista clara para navegar los modelos de suelo y abrir cada ficha con su información técnica y visual.",
    },
  },
  "en-US": {
    muro: {
      overviewTitle: "Explore every piece as a high-detail material library.",
      overviewDescription: `An editorial view to browse the pieces that make up ${getCollectionNaming("en-US", "muro").title} with quick access to each design and its technical sheet.`,
    },
    celosias: {
      overviewTitle: "Explore every screen as a module of light, shadow and ventilation.",
      overviewDescription: "An editorial overview to browse all the screen patterns with quick access to each technical sheet.",
    },
    paneles: {
      overviewTitle: "Explore every panel as a precise, architectural surface.",
      overviewDescription: "A curated reading to review formats, finishes and material presence before opening each individual panel.",
    },
    pisos: {
      overviewTitle: "Explore every floor as an architectural material base.",
      overviewDescription: "A clear overview to browse floor models and open each detail page with its technical and visual information.",
    },
  },
};

const buildCollectionUiForLocale = (localeKey) =>
  Object.fromEntries(
    Object.keys(collectionOverviewCopyByLocale[localeKey]).map((collectionId) => {
      const naming = getCollectionNaming(localeKey, collectionId);

      return [
      collectionId,
      {
        ...sharedCollectionUi[localeKey],
        overviewKicker: localeKey === "en-US" ? `${naming.upperTitle} DESIGNS` : `Diseños ${naming.title}`,
        ...collectionOverviewCopyByLocale[localeKey][collectionId],
      },
      ];
    }),
  );

const collectionDesignUiByLocale = {
  "es-MX": buildCollectionUiForLocale("es-MX"),
  "es-ES": buildCollectionUiForLocale("es-ES"),
  "en-US": buildCollectionUiForLocale("en-US"),
};

const collectionDesigns = {
  muro: muroDesigns,
  celosias: [],
  paneles: [],
  pisos: [],
};

const resourcePdfUrls = {
  tileUnloading: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/n8fabfbv_Manual-de-descarga.pdf",
  panelsUnloading: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/17dy83oy_Manual-de-descarga-Paneles-Arista-Vertice.pdf",
  screensUnloading: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/j1gqiwwd_Manual-de-descarga-Celosias-Paneles-Arista-Vertice.pdf",
  floorInstallation: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/2vf80nz9_Manual_Floor%20US.pdf",
  tilesPanelsInstallation: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/em9t5is2_Manual_tilesPanels.pdf",
  screensInstallation: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/v77ww402_ManualBreezeBlocks.pdf",
  maintenance: "https://customer-assets.emergentagent.com/job_luxury-concrete-1/artifacts/511k9cqw_Limpieza-y-mantenimiento.pdf",
};

const resourceFilesByLocale = {
  "es-MX": [
    {
      id: "manual-descarga",
      title: "Manual de descarga de losetas",
      description: "Recomendaciones de maniobra, descarga y cuidado del producto al recibirlo.",
      href: resourcePdfUrls.tileUnloading,
      filename: "manual-descarga-losetas.pdf",
    },
    {
      id: "manual-instalacion",
      title: "Manual de instalación de losetas",
      description: "Proceso base de instalación para losetas y su correcta aplicación en obra.",
      href: resourcePdfUrls.floorInstallation,
      filename: "manual-instalacion-losetas.pdf",
    },
    {
      id: "manual-mantenimiento",
      title: "Manual de mantenimiento y limpieza",
      description: "Lineamientos para conservar la apariencia del material y su lectura superficial.",
      href: resourcePdfUrls.maintenance,
      filename: "manual-mantenimiento-limpieza.pdf",
    },
  ],
  "es-ES": [
    {
      id: "manual-descarga",
      title: "Manual de descarga de losetas",
      description: "Recomendaciones de maniobra, descarga y cuidado del producto al recibirlo.",
      href: resourcePdfUrls.tileUnloading,
      filename: "manual-descarga-losetas.pdf",
    },
    {
      id: "manual-instalacion",
      title: "Manual de instalación de losetas",
      description: "Proceso base de instalación para losetas y su correcta aplicación en obra.",
      href: resourcePdfUrls.floorInstallation,
      filename: "manual-instalacion-losetas.pdf",
    },
    {
      id: "manual-mantenimiento",
      title: "Manual de mantenimiento y limpieza",
      description: "Criterios para conservar la apariencia del material y su lectura superficial.",
      href: resourcePdfUrls.maintenance,
      filename: "manual-mantenimiento-limpieza.pdf",
    },
  ],
  "en-US": [
    {
      id: "manual-unloading",
      title: "Tile unloading manual",
      description: "Recommendations for handling, unloading and protecting the product on arrival.",
      href: resourcePdfUrls.tileUnloading,
      filename: "tile-unloading-manual.pdf",
    },
    {
      id: "manual-installation",
      title: "Tile installation manual",
      description: "Base installation process for tile applications and a correct on-site assembly.",
      href: resourcePdfUrls.floorInstallation,
      filename: "tile-installation-manual.pdf",
    },
    {
      id: "manual-maintenance",
      title: "Maintenance and cleaning manual",
      description: "Guidance to preserve the material appearance and surface reading over time.",
      href: resourcePdfUrls.maintenance,
      filename: "maintenance-cleaning-manual.pdf",
    },
  ],
};

const resourceOverridesByCollectionAndLocale = {
  muro: {
    "es-MX": {
      "manual-instalacion": {
        title: "Manual de instalación de losetas",
        description: "Proceso de instalación para losetas en muros, con preparación de superficie y recomendaciones de aplicación.",
        href: resourcePdfUrls.tilesPanelsInstallation,
        filename: "manual-instalacion-losetas-muro.pdf",
      },
    },
    "es-ES": {
      "manual-instalacion": {
        title: "Manual de instalación de losetas",
        description: "Proceso de instalación para losetas en muros, con preparación de superficie y recomendaciones de aplicación.",
        href: resourcePdfUrls.tilesPanelsInstallation,
        filename: "manual-instalacion-losetas-muro.pdf",
      },
    },
    "en-US": {
      "manual-installation": {
        title: "Concrete wall tiles installation manual",
        description: "Installation guidance for decorative concrete wall tiles, including site preparation and essential care steps.",
        href: resourcePdfUrls.tilesPanelsInstallation,
        filename: "concrete-wall-tiles-installation-manual.pdf",
      },
    },
  },
  pisos: {
    "es-MX": {},
    "es-ES": {},
    "en-US": {},
  },
  paneles: {
    "es-MX": {
      "manual-descarga": {
        title: "Manual de descarga de paneles",
        description: "Recomendaciones específicas para descarga y maniobra segura de paneles en sitio.",
        href: resourcePdfUrls.panelsUnloading,
        filename: "manual-descarga-paneles.pdf",
      },
      "manual-instalacion": {
        title: "Manual de instalación de losetas y paneles",
        description: "Proceso de instalación para losetas y paneles, incluyendo preparación de obra y recomendaciones de aplicación.",
        href: resourcePdfUrls.tilesPanelsInstallation,
        filename: "manual-instalacion-losetas-paneles.pdf",
      },
    },
    "es-ES": {
      "manual-descarga": {
        title: "Manual de descarga de paneles",
        description: "Recomendaciones específicas para descarga y maniobra segura de paneles en obra.",
        href: resourcePdfUrls.panelsUnloading,
        filename: "manual-descarga-paneles.pdf",
      },
      "manual-instalacion": {
        title: "Manual de instalación de losetas y paneles",
        description: "Proceso de instalación para losetas y paneles, incluyendo preparación de obra y recomendaciones de aplicación.",
        href: resourcePdfUrls.tilesPanelsInstallation,
        filename: "manual-instalacion-losetas-paneles.pdf",
      },
    },
    "en-US": {
      "manual-unloading": {
        title: "Decorative concrete panels unloading manual",
        description: "Specific unloading and handling guidance for decorative concrete panels on site.",
        href: resourcePdfUrls.panelsUnloading,
        filename: "decorative-concrete-panels-unloading-manual.pdf",
      },
      "manual-installation": {
        title: "Decorative concrete panels and concrete wall tiles installation manual",
        description: "Installation guidance for decorative concrete panels and concrete wall tiles, including site preparation and care recommendations.",
        href: resourcePdfUrls.tilesPanelsInstallation,
        filename: "decorative-concrete-panels-and-concrete-wall-tiles-installation-manual.pdf",
      },
    },
  },
  celosias: {
    "es-MX": {
      "manual-descarga": {
        title: "Manual de descarga de paneles de celosías",
        description: "Proceso de maniobra y recomendaciones para celosías, muros divisorios y piezas modulares especiales.",
        href: resourcePdfUrls.screensUnloading,
        filename: "manual-descarga-celosias.pdf",
      },
      "manual-instalacion": {
        title: "Manual de instalación de celosías",
        description: "Proceso base de instalación para celosías y muros divisorios, asegurando un montaje correcto en obra.",
        href: resourcePdfUrls.screensInstallation,
        filename: "manual-instalacion-celosias.pdf",
      },
    },
    "es-ES": {
      "manual-descarga": {
        title: "Manual de descarga de paneles de celosías",
        description: "Proceso de maniobra y recomendaciones para celosías, muros divisorios y piezas modulares especiales.",
        href: resourcePdfUrls.screensUnloading,
        filename: "manual-descarga-celosias.pdf",
      },
      "manual-instalacion": {
        title: "Manual de instalación de celosías",
        description: "Proceso base de instalación para celosías y muros divisorios, asegurando un montaje correcto en obra.",
        href: resourcePdfUrls.screensInstallation,
        filename: "manual-instalacion-celosias.pdf",
      },
    },
    "en-US": {
      "manual-unloading": {
        title: "Concrete screens unloading manual",
        description: "Handling and unloading guidance for concrete screens, divider walls and modular breeze block systems.",
        href: resourcePdfUrls.screensUnloading,
        filename: "concrete-screens-unloading-manual.pdf",
      },
      "manual-installation": {
        title: `${getCollectionNaming("en-US", "celosias").title} installation manual`,
        description: `Base installation process for ${getCollectionNaming("en-US", "celosias").designPluralLabel} and divider walls to ensure a correct on-site assembly.`,
        href: resourcePdfUrls.screensInstallation,
        filename: "concrete-screens-installation-manual.pdf",
      },
    },
  },
};

const designDetailUiByLocale = {
  "es-MX": {
    backLink: "Volver a MURO",
    collectionLabel: "Colección",
    suitabilityLabel: "Apto para",
    interiorLabel: "Interior",
    exteriorLabel: "Exterior",
    measurementTitle: "Plano de medidas",
    measurementDescription:
      "*Cotas en centímetros\n*Dado a los procesos artesanales de fabricación las piezas pueden presentar variaciones de medidas entre pieza y pieza.",
    measurementWidthLabel: "Ancho",
    measurementHeightLabel: "Alto",
    measurementDepthLabel: "Profundidad",
    galleryKicker: "Galería",
    galleryTitle: "Lecturas visuales de la pieza.",
    galleryDescription: "Una vista limpia para revisar geometría, relieve y presencia material del diseño antes de especificarlo.",
    resourcesKicker: "Manuales y recursos",
    resourcesTitle: "Todo el soporte técnico y operativo en un solo lugar.",
    resourcesDescription: "Consulta nuestros manuales y realiza un correcto manejo y uso de nuestras tendencias.",
    quoteKicker: "Cotizar esta tendencia",
    quoteTitle: "Solicitar cotización",
    quoteDescription: "Comparte los datos clave del proyecto para preparar una propuesta más precisa sobre esta pieza.",
    quoteRequiredNote: "Todos los campos son obligatorios.",
    embedKicker: "Explora en 3D",
    embedTitle: "Vista 3D y Realidad aumentada.",
    embedDescription: "Explora nuestras tendencias desde cualquier perspectiva y utiliza la realidad aumentada para vivirlas.",
    embedPieceLabel: "Vista 3D de la pieza",
    embedSquareLabel: "Vista 3D de un m²",
    quoteForm: {
      name: "Nombre",
      company: "Empresa",
      email: "Email",
      phone: "Teléfono",
      city: "Ciudad",
      trend: "Tendencia",
      sqm: "m²",
      color: "Color",
      texture: "Textura",
      finish: "Acabado",
      comments: "Comentarios / Observaciones",
      submit: "Cotizar esta tendencia",
      whatsappSubmit: "Cotizar por WhatsApp",
      whatsappIntro: "Hola, quiero cotizar la siguiente tendencia de Arista + Vértice:",
      whatsappError: "No encontramos el WhatsApp de ventas en este momento.",
      success: "Abriendo WhatsApp con el resumen de tu solicitud.",
      emailSubmit: "Solicitar por correo",
      phoneSubmit: "Solicitar cotización",
      emailIntro: "Hola, quiero solicitar una cotización para la siguiente tendencia de Arista + Vértice:",
      emailSuccess: "Abriendo correo con el resumen de tu solicitud.",
      contactError: "No encontramos un canal comercial disponible en este momento.",
    },
    systemKicker: "Color · textura · acabado",
    systemTitle: "Diseña tu tendencia.",
    systemDescription: "Previsualiza una lectura más editorial de color, textura y acabado para entender cómo dialogan sobre esta pieza.",
    previewCta: "Vista previa",
    downloadCta: "Descargar",
    sourceCta: "Ver en sitio original",
    contactCta: "Solicita información",
    previousCta: "Diseño anterior",
    nextCta: "Diseño siguiente",
    systemLinks: [
      { id: "colores", title: "Colores", description: "Una selección de tonos de línea y metálicos para visualizar la atmósfera general.", to: "/colores" },
      { id: "texturas", title: "Texturas", description: "Superficies base con distinta profundidad y porosidad para esta tendencia.", to: "/texturas" },
      { id: "acabados", title: "Acabados", description: "Lecturas de brillo y reflexión para cerrar la presencia final de la pieza.", to: "/acabados" },
    ],
  },
  "es-ES": {
    backLink: "Volver a MURO",
    collectionLabel: "Colección",
    suitabilityLabel: "Apto para",
    interiorLabel: "Interior",
    exteriorLabel: "Exterior",
    measurementTitle: "Plano de medidas",
    measurementDescription:
      "*Cotas en centímetros\n*Dado a los procesos artesanales de fabricación las piezas pueden presentar variaciones de medidas entre pieza y pieza.",
    measurementWidthLabel: "Ancho",
    measurementHeightLabel: "Alto",
    measurementDepthLabel: "Profundidad",
    galleryKicker: "Galería",
    galleryTitle: "Lecturas visuales de la pieza.",
    galleryDescription: "Una vista limpia para revisar geometría, relieve y presencia material del diseño antes de especificarlo.",
    resourcesKicker: "Manuales y recursos",
    resourcesTitle: "Todo el soporte técnico y operativo en un solo lugar.",
    resourcesDescription: "Consulta nuestros manuales y realiza un correcto manejo y uso de nuestras tendencias.",
    quoteKicker: "Cotizar esta tendencia",
    quoteTitle: "Solicitar cotización",
    quoteDescription: "Comparte los datos clave del proyecto para preparar una propuesta más precisa sobre esta pieza.",
    quoteRequiredNote: "Todos los campos son obligatorios.",
    embedKicker: "Explora en 3D",
    embedTitle: "Vista 3D y Realidad aumentada.",
    embedDescription: "Explora nuestras tendencias desde cualquier perspectiva y utiliza la realidad aumentada para vivirlas.",
    embedPieceLabel: "Vista 3D de la pieza",
    embedSquareLabel: "Vista 3D de un m²",
    quoteForm: {
      name: "Nombre",
      company: "Empresa",
      email: "Email",
      phone: "Teléfono",
      city: "Ciudad",
      trend: "Tendencia",
      sqm: "m²",
      color: "Color",
      texture: "Textura",
      finish: "Acabado",
      comments: "Comentarios / Observaciones",
      submit: "Solicitar cotización",
      whatsappSubmit: "Cotizar por WhatsApp",
      whatsappIntro: "Hola, quiero cotizar la siguiente tendencia de Arista + Vértice:",
      whatsappError: "No encontramos el WhatsApp de ventas en este momento.",
      success: "Abriendo WhatsApp con el resumen de tu solicitud.",
      emailSubmit: "Solicitar por correo",
      phoneSubmit: "Solicitar cotización",
      emailIntro: "Hola, quiero solicitar una cotización para la siguiente tendencia de Arista + Vértice:",
      emailSuccess: "Abriendo correo con el resumen de tu solicitud.",
      contactError: "No encontramos un canal comercial disponible en este momento.",
    },
    systemKicker: "Color · textura · acabado",
    systemTitle: "Diseña tu tendencia.",
    systemDescription: "Previsualiza una lectura más editorial de color, textura y acabado para entender cómo dialogan sobre esta pieza.",
    previewCta: "Vista previa",
    downloadCta: "Descargar",
    sourceCta: "Ver en sitio original",
    contactCta: "Solicita información",
    previousCta: "Diseño anterior",
    nextCta: "Diseño siguiente",
    systemLinks: [
      { id: "colores", title: "Colores", description: "Una selección de tonos de línea y metálicos para visualizar la atmósfera general.", to: "/colores" },
      { id: "texturas", title: "Texturas", description: "Superficies base con distinta profundidad y porosidad para esta tendencia.", to: "/texturas" },
      { id: "acabados", title: "Acabados", description: "Lecturas de brillo y reflexión para cerrar la presencia final de la pieza.", to: "/acabados" },
    ],
  },
  "en-US": {
    backLink: "Back to MURO",
    collectionLabel: "Collection",
    suitabilityLabel: "Suitable for",
    interiorLabel: "Interior",
    exteriorLabel: "Exterior",
    measurementTitle: "Dimension plan",
    measurementDescription: "*Measurements in centimeters\n*Due to the handcrafted manufacturing process, pieces may show dimensional variation from one piece to another.",
    measurementWidthLabel: "Width",
    measurementHeightLabel: "Height",
    measurementDepthLabel: "Depth",
    galleryKicker: "Gallery",
    galleryTitle: "Visual readings of the piece.",
    galleryDescription: "A calm, precise view to review geometry, relief and material presence before specifying the piece.",
    resourcesKicker: "Manuals and resources",
    resourcesTitle: "All technical and operational support in one place.",
    resourcesDescription: "Maintenance, installation and unloading documents remain accessible from every design so the commercial flow stays uninterrupted.",
    quoteKicker: "Quote this trend",
    quoteTitle: "Request a quote",
    quoteDescription: "Share the key project details so we can prepare a more precise proposal around this piece.",
    quoteRequiredNote: "All fields are required.",
    embedKicker: "Explore in 3D",
    embedTitle: "3D view of the piece and the square meter.",
    embedDescription: "Two interactive windows to review the design as an individual piece and as an applied one-square-meter composition.",
    embedPieceLabel: "3D view of the piece",
    embedSquareLabel: "3D view of one m²",
    quoteForm: {
      name: "Name",
      company: "Company",
      email: "Email",
      phone: "Phone",
      city: "City",
      trend: "Trend",
      sqm: "m²",
      color: "Color",
      texture: "Texture",
      finish: "Finish",
      comments: "Comments / Notes",
      submit: "Quote this trend",
      whatsappSubmit: "Quote via WhatsApp",
      whatsappIntro: "Hello, I would like to request a quote for the following Arista + Vértice trend:",
      whatsappError: "The sales WhatsApp number is not available right now.",
      success: "Opening WhatsApp with your request summary.",
      emailSubmit: "Request by email",
      phoneSubmit: "Request a quote",
      emailIntro: "Hello, I would like to request a quote for the following Arista + Vértice trend:",
      emailSuccess: "Opening email with your request summary.",
      contactError: "We couldn't find an active commercial channel right now.",
    },
    systemKicker: "Color · texture · finish",
    systemTitle: "Design your trend.",
    systemDescription: "Preview a more editorial read of color, texture and finish to understand how the three layers work together on this piece.",
    previewCta: "Preview",
    downloadCta: "Download",
    sourceCta: "View original source",
    contactCta: "Request information",
    previousCta: "Previous design",
    nextCta: "Next design",
    systemLinks: [
      { id: "colors", title: "Colors", description: "A curated selection of core and metallic tones to preview the overall atmosphere.", to: "/colores" },
      { id: "textures", title: "Textures", description: "Base surfaces with different depth and porosity for this trend.", to: "/texturas" },
      { id: "finishes", title: "Finishes", description: "Gloss and reflection studies to define the final presence of the piece.", to: "/acabados" },
    ],
  },
};

const normalizeLocale = (locale) => {
  if (locale === "en-US") {
    return "en-US";
  }

  if (locale === "es-ES") {
    return "es-ES";
  }

  return "es-MX";
};

const resolveDesignDescription = (description, localeCode) => {
  if (typeof description === "string") {
    return description;
  }

  if (!description) {
    return "";
  }

  return description[localeCode] || description.es || description.en || "";
};

const formatOverviewMetric = (design) => {
  if (design.variants?.length) {
    return design.variants[0]?.dimensions || null;
  }

  return design.specs?.dimensions || null;
};

const getResourceFilesForCollection = (locale, collectionId) => {
  const resources = resourceFilesByLocale[locale] || [];
  const collectionOverrides = resourceOverridesByCollectionAndLocale[collectionId]?.[locale];

  if (!collectionOverrides) {
    return resources;
  }

  return resources.map((resource) => (collectionOverrides[resource.id] ? { ...resource, ...collectionOverrides[resource.id] } : resource));
};

export const getCollectionDesignContent = (locale, collectionId, source = collectionDesigns) => {
  const designs = source[collectionId];
  if (!designs?.length) {
    return null;
  }

  const safeLocale = normalizeLocale(locale);
  const localeCode = safeLocale === "en-US" ? "en" : "es";
  const ui = collectionDesignUiByLocale[safeLocale]?.[collectionId];

  if (!ui) {
    return null;
  }

  return {
    ui,
    designs: designs.map((design) => ({
      ...design,
      description: resolveDesignDescription(design.description, localeCode),
      overviewMetric: formatOverviewMetric(design),
    })),
  };
};

export const getCollectionDesignById = (locale, collectionId, designId, source = collectionDesigns) => {
  const content = getCollectionDesignContent(locale, collectionId, source);
  const safeLocale = normalizeLocale(locale);
  const design = content?.designs.find((item) => item.id === designId);
  const detailUi = designDetailUiByLocale[safeLocale];
  const collectionTitle = getCollectionNaming(safeLocale, collectionId).title;
  const backLink = safeLocale === "en-US" ? `Back to ${collectionTitle}` : `Volver a ${collectionTitle}`;

  if (!content || !design || !detailUi) {
    return null;
  }

  return {
    ui: {
      ...content.ui,
      ...detailUi,
      backLink,
    },
    design,
    resources: getResourceFilesForCollection(safeLocale, collectionId),
  };
};

export const getStaticMuroImportPayload = () =>
  muroDesigns.map((design, index) => ({
    ...design,
    collectionId: "muro",
    sortOrder: index,
    isPublished: true,
    embeds: getDesignEmbeds("muro", design.id) || null,
  }));